import { STATS } from "@/data/site";
import { Counter, FadeUp, Chapter } from "./motion";

export default function Stats() {
  return (
    <section id="stats" data-testid="stats-section" className="bg-[#F7F5F2] py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Chapter num="01" title="The Proof" />
        <div className="mt-14 grid grid-cols-2 gap-y-14 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <FadeUp key={s.label} delay={i * 0.12} className={`px-2 lg:px-10 ${i > 0 ? "lg:border-l hairline" : ""}`} >
              <p data-testid={`stat-value-${i}`} className="font-num text-5xl font-semibold tracking-tight text-[#1B1B1B] md:text-6xl">
                <Counter value={s.value} suffix={s.suffix} />
              </p>
              <p className="mt-3 text-xs font-medium uppercase tracking-[0.25em] text-[#2C2C2C]/55">{s.label}</p>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
